import React, { useState, useEffect } from "react";
import Layout from "../components/Global/layout";
import { Link, graphql } from "gatsby";
import SpotlightDetail from "../components/Global/spotlightDetail";
import SiteTrans from "../components/LangConfig/siteTrans.json";

// import Function from "../lib/functions";
import termsAndConditionsClip from "../common/images/TermsAndConditions/termsAndConditionsClip.png";
import newsDetailsSpotlightBanner from "../common/images/NewsInsightsList/newsDetailsSpotlightBanner.png";
import BreadcrumbSchema from "../components/BreadcrumbSchema";

const PageTemplate = (props) => {
  const currentPage = props.data.wpPage;
  // console.log(currentPage,"currentPage translation");
  const spotlightDetail = currentPage.spotlightDetail;
  const [isAboveRefPoint, setIsAboveRefPoint] = useState(true);
  const headerListenToScroll = () => {
    const newsInsightsSectionPosition = document.getElementById(
      "spotlight-detail-title-ref"
    )?.offsetTop;
    const scrollPosition = window.scrollY;

    if (scrollPosition < newsInsightsSectionPosition) {
      setIsAboveRefPoint(true);
    } else {
      setIsAboveRefPoint(false);
    }
  };


  useEffect(() => onPreRouteUpdate());
  const onPreRouteUpdate = () => {
  
      // Function.LoadingAllSliderScript();
}



  const [links, setLinks] = useState({})

  useEffect(() => {
    window.addEventListener("scroll", headerListenToScroll);
    return () => {
      window.removeEventListener("scroll", headerListenToScroll);
    };
  }, []);

  const triggerScroll = () => {

    document.getElementById("news-insights-ref")?.scrollIntoView();
  };

  const isActive = ({ isCurrent }) => {
    return isCurrent ? { className: "active-link" } : {};
  };

  useEffect(() => {
 
    if (props.data.wpPage.slug.includes('our-story') || props.data.wpPage.slug.includes('our-values')) {
      const links = {
        tabLink: [
          {
            label: SiteTrans.Whoweare.our_story,
            route: SiteTrans.Whoweare.route_our_story,
          },
          {
            label: SiteTrans.Whoweare.our_values,
            route: SiteTrans.Whoweare.route_our_values,
          },
          {
            label: SiteTrans.Whoweare.our_people,
            route: SiteTrans.Whoweare.route_our_people,
          },
        ],
      };
      // const links = { tabLink: [{ label: "OUR STORY", route: '/en/our-story/' }, { label: "OUR VALUES & THE JAMEEL PRINCIPLES", route: '/en/our-values/' }, { label: "OUR PEOPLE", route: '/en/our-people/' }] }
      setLinks(links)
    }
    else {
      setLinks(null)
    }
  }, [props.data.wpPage.slug])

  const publishedTranslatedLinks = currentPage.translated.filter(translation =>
    translation.locale.id === 'en_US' &&
    translation.localizedWpmlUrl && 
    translation.publishStatus.status !== 'private'
  );

  const link = currentPage.link // Original link
  const translatedLink = publishedTranslatedLinks.length > 0 ? publishedTranslatedLinks[0].localizedWpmlUrl : currentPage.localizedWpmlUrl;
  const segments = link.split('/'); // Split the link by slashes
  const translatedsegments = translatedLink.split('/'); 
  const modifiedLink = segments.filter(segment => segment !== 'home').join('/'); // Remove "home" and join the segments
  const translatedmodifiedLink = translatedsegments.filter(segment => segment !== 'home').join('/'); 

//   const modifiedLinks = [];
// const translatedModifiedLinks = [];

// currentPage.translated.forEach(translation => {
//     if (translation.localizedWpmlUrl && translation.publishStatus.status !== 'private') {
//         const translatedLink = translation.localizedWpmlUrl;
//         const segments = currentPage.link.split('/'); // Split the original link by slashes
//         const translatedSegments = translatedLink.split('/'); // Split the translated link by slashes

//         // Remove "home" segment from both original and translated links
//         const modifiedLink = segments.filter(segment => segment !== 'home').join('/');
//         const translatedModifiedLink = translatedSegments.filter(segment => segment !== 'home').join('/');

//         modifiedLinks.push(modifiedLink);
//         translatedModifiedLinks.push(translatedModifiedLink);
//     }
// });


  const contactpagelink = currentPage.locale.id === 'en_US' ? 'en' : currentPage.locale.id === 'ar' ? 'ar' : 'zh-hans'

  console.log(currentPage.translated,"currentPage.translated");
  return (
    <>
      <Layout isAboveRefPoint={isAboveRefPoint} translations={currentPage.translated} lang={currentPage.locale.id} translateURL={translatedmodifiedLink}
      langURL={modifiedLink} title={currentPage.seo.opengraphTitle ? currentPage.seo.opengraphTitle : null}
      description={currentPage.seo.opengraphDescription ? currentPage.seo.opengraphDescription : null}
      image={currentPage.featuredImage.node.sourceUrl ? currentPage.featuredImage.node.sourceUrl : null} currentPage={currentPage} pageUrl={currentPage.link} pageId={currentPage.locale.id}>
        <BreadcrumbSchema
                    PageTitle={currentPage.title}
                    defaultPageName={"Home"}
                    pageUrl={"https://jameelmotors.com"+currentPage.link}
                    langUrl={"https://jameelmotors.com/"+contactpagelink}
                />
        <section className="terms-and-conditions-wrapper">
          <SpotlightDetail
            spotlightDetail={spotlightDetail}
            clipImage={termsAndConditionsClip}
            image={currentPage.featuredImage ? currentPage.featuredImage.node : newsDetailsSpotlightBanner}
            triggerScroll={triggerScroll}
            links=''
            title={currentPage.title}
            description=""
            lang={currentPage.locale.id}
          />
          <div id="news-insights-ref" className="news-insights-ref"></div>
          <div className="">
            {links !== null &&
              <div className=" position-relative">
                <div className="container position-relative z-2">
                  <div className="news-insights-list-tabs-wrapper row row-cols-auto justify-content-center flex-md-row flex-column gap-md-0 gap-3">
                    {links?.tabLink?.map((linkElements) => {
                      return (<>
                        <Link getProps={isActive} to={linkElements.route}>
                          <div className="link-active news-nav-links text-center">{linkElements.label}</div>
                        </Link>
                      </>)
                    })}
                  </div>
                </div>
              </div>
            }
            <div className="position-relative news-details-content">
                <div className="auxiliaryPage">
              <div
              className="customPageWrapper"
                dangerouslySetInnerHTML={{
                  __html: currentPage.content,
                }}
              />
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default PageTemplate;
export const pageQuery = graphql`
  query currentPageQuery($id: String!) {
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      link
      uri
      id
      localizedWpmlUrl
      seo {
        opengraphTitle
        opengraphDescription
      }
      spotlightDetail {
        spotlightVideo {
          mediaItemUrl
          sourceUrl
          localFile {
            url
          }
        }
        spotlightImageOrSpotlightVideo
      }
      featuredImage {
        node {
          sourceUrl
          gatsbyImage(width: 1920, placeholder: BLURRED)
          altText
        }
      }
      locale {
        id
        locale
      }
      translated {
        id
        uri
        localizedWpmlUrl
        locale {
          id
          locale
        }
        publishStatus {
          status
        }
        slug
        title
        link
      }
    }
  }
`;
